export default {
  CREATOR: 'CREATOR',
  SIGNER: 'SIGNER',
  CREATOR_AND_SIGNER: 'CREATOR_AND_SIGNER',
  VIEWER: 'VIEWER',
  CLERK: 'CLERK',
  APPROVER: 'APPROVER'
}
